<template>
  <div class="row">
    <div id="home" class="col-sm-12 text-center">
      <div class="background">
        <h1>
          欢迎大家品尝pizza!
        </h1>
        <h2>
          有你非常喜欢的pizza!
        </h2>
        <button @click="goToBefore" class="btn btn-success">跳转到上一次页面</button>
        <button @click="goToMenu" class="btn btn-success">跳转到指定menu</button>
        <button @click="goToRouterName" class="btn btn-success">跳转到指定路由的名字下</button>
        <button @click="pushMenu" class="btn btn-success">push跳转</button>
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    methods: {
      goToBefore() {
        //跳转到上一次浏览的页面
        this.$router.go(-1);
      },
      //指定跳转的地址
      goToMenu() {
        this.$router.replace("/menu");
      },
      //指定跳转路由的名字下
      goToRouterName() {
        this.$router.replace({name: 'menulink'});
      },
      //通过push进行跳转
      pushMenu() {
        // this.$router.push('/menu');
        this.$router.push({name: 'menulink'});
      }

    }
  }
</script>

<style scoped>

#home{
  background: url('../assets/pie.png');
  height:85vh;
  padding:10%;
}
  h1,h2{
    margin:6%;
  }
   .background{
     background:#eee;
     opacity:0.8;
     max-width:70vw;
     margin:0 auto;
     padding:20px 0;
   }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue